import { theme } from 'antd';

const { useToken } = theme;
const useTheme = () => {
    const { token } = useToken();
    return token;
};

export default useTheme;
